import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getRoomById = async (id: number) => {
  const url = endpoints.ROOM + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createRoom = async (params: any) => {
  const url = endpoints.ROOM;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateRoom = async (params: any) => {
  const url = endpoints.ROOM + "/" + params.id;

  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteRoom = async (id: number) => {
  const url = endpoints.ROOM + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const addPhoto = async (params: any) => {
  const url = endpoints.ROOM + "/photo";

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deletePhoto = async (id: number) => {
  const url = endpoints.ROOM + "/photo/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const services = {
  createRoom,
  updateRoom,
  deleteRoom,
  getRoomById,
  addPhoto,
  deletePhoto
};

export default services;
